import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { DateTime } from 'luxon';

export default function CourseInfo() {
  const theme = useTheme();


  const generalinfo = (
    <Card sx={{ display: 'flex', alignContent: 'space-between' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            OUR TRAINING COURSES
          </Typography>
          <Typography component="div" variant="h3">
            CIRCUIT & FUNCTIONAL TRAINING 
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            พบกับคอร์สฟิตแบบสนุกๆ กับโค้ชเราได้ทุกวันอังคารและพฤหัสบดี เวลาประมาณ 1800
          </Typography>
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
          {/* <IconButton aria-label="previous">
            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}
          </IconButton>
          <IconButton aria-label="play/pause">
            <PlayArrowIcon sx={{ height: 38, width: 38 }} />
          </IconButton>
          <IconButton aria-label="next">
            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
          </IconButton> */}
          <Typography variant="subtitle1" color="text.secondary" component="div">
            สอบถามการเข้าร่วมคอร์สได้ในไลน์ ⇨ 
          </Typography>
        </Box>
      </Box>
      <Box flexGrow={1} />
      <CardMedia
        component="img"
        sx={{ display: 'flex',   width: 151, height: 151}}
        image="/assets/L_gainfriends_2dbarcodes_BW.jpg"
        alt="The Runway QR CODE"
      />
    </Card>
  )

  const functionalinfo = (
    <Card sx={{ display: 'flex', bgcolor: 'darkorange', alignContent: 'space-between' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            TODAY's COURSE
          </Typography>
          <Typography component="div" variant="h3">
            FUNCTIONAL TRAINING 
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            by Coach Benzt
          </Typography>
          <Typography component="div" variant="h6">
            TIME: 1800 
          </Typography>
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
          {/* <IconButton aria-label="previous">
            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}
          </IconButton>
          <IconButton aria-label="play/pause">
            <PlayArrowIcon sx={{ height: 38, width: 38 }} />
          </IconButton>
          <IconButton aria-label="next">
            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
          </IconButton> */}
          <Typography variant="subtitle1" color="text.secondary" component="div">
            เข้าร่วมคอร์ส พิมพ์ "functional" ในไลน์ ⇨ 
          </Typography>
        </Box>
      </Box>
      <Box flexGrow={1} />
      <CardMedia
        component="img"
        sx={{ width: 151, height: 151}}
        image="/assets/L_gainfriends_2dbarcodes_BW.jpg"
        alt="The Runway QR CODE"
      />
    </Card>
  )
  
  const circuitinfo = (
    <Card sx={{ display: 'flex', bgcolor: 'darkorange', alignContent: 'space-between' }}>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            TODAY's COURSE
          </Typography>
          <Typography component="div" variant="h3">
            CIRCUIT TRAINING 
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" component="div">
            by Coach Benzt
          </Typography>
          <Typography component="div" variant="h6">
            TIME: 1800 
          </Typography>
        </CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
          {/* <IconButton aria-label="previous">
            {theme.direction === 'rtl' ? <SkipNextIcon /> : <SkipPreviousIcon />}
          </IconButton>
          <IconButton aria-label="play/pause">
            <PlayArrowIcon sx={{ height: 38, width: 38 }} />
          </IconButton>
          <IconButton aria-label="next">
            {theme.direction === 'rtl' ? <SkipPreviousIcon /> : <SkipNextIcon />}
          </IconButton> */}
          <Typography variant="subtitle1" color="text.secondary" component="div">
            เข้าร่วมคอร์ส พิมพ์ "circuit" ในไลน์ ⇨ 
          </Typography>
        </Box>
      </Box>
      <Box flexGrow={1} />
      <CardMedia
        component="img"
        sx={{ width: 151, height: 151}}
        image="/assets/L_gainfriends_2dbarcodes_BW.jpg"
        alt="The Runway QR CODE"
      />
    </Card>
  )


  // return (<></>)
  const { weekday } = DateTime.local().startOf('day')
  switch (weekday) {
    case 2:
      return circuitinfo
  
    // case 4:
    //   return functionalinfo
  
    default:
      return generalinfo;
  }
}